import { useGetPrivacyPolicyQuery } from "@/app/features/config/configApiSlice";
import ConfigWrapper from "@/pages/configuration/components/ConfigWrapper";
import ShowHtmlContent from "@/pages/configuration/components/ShowHtmlContent";
import { CircularProgress, Typography } from "@mui/material";

function PrivacyPolicyPage() {
  const { data, isLoading, error } = useGetPrivacyPolicyQuery();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Typography align="center" sx={{ mb: 3 }} variant="h3">
        Something went wrong
      </Typography>
    );
  }

  return (
    <ConfigWrapper title="Privacy Policy">
      <ShowHtmlContent content={data.privacyPolicy.privacyPolicyDetail} />
    </ConfigWrapper>
  );
}

export default PrivacyPolicyPage;
